import Widgets from 'js-widget-hooks';

Widgets.register('map', function (el) {
    import(/* webpackChunkName: "map" */ '../module/map.jsx').then(function (module) {
        module.default(el);
    });
});